<template>
  <header class="header">
    <nav class="navbar fixed-top">
      <!-- Begin Search Box-->
      <div class="search-box">
        <button class="dismiss"><i class="ion-close-round"></i></button>
        <form id="searchForm" action="#" role="search">
          <input type="search" placeholder="جستجو کنید ..." class="form-control" />
        </form>
      </div>
      <!-- End Search Box-->
      <!-- Begin Topbar -->
      <div class="navbar-holder d-flex align-items-center align-middle justify-content-between">
        <!-- Begin Logo -->

        <div class="">
          <a href="/dashboard" class="navbar-brand"
            ><div class="brand-image brand-big">
              <img src="../../../assets/logo.png" alt="logo" class="logo-big" style="height: 50px;" /></div
          ></a>
        </div>

        <!-- End Logo -->

        <!-- End Navbar Menu -->
      </div>
      <!-- End Topbar -->
    </nav>
  </header>
</template>

<script>
export default {
  name: 'HeaderMain',
};
</script>
